const state = {
    dialog: false,
    padrao: '',
    dados: {
        cronograma_id: null,
        operadora_ans_id: null,
        oper_nome: null,
        prestador_id: null,
        prest_nome: null,
        dt_faturamento: null,
        dt_prev_vencimento: null,
        qt_arq: null,
        complementar: null,
    },
    parametros:{}
}
const mutations = {
    showNotas: (state, opts) => {
        state.parametros = opts.parametros
        state.dialog = true,
        state.padrao = opts.padrao ?opts.padrao : 'NA'
        state.dados.cronograma_id = opts.dados.id
        state.dados.operadora_ans_id = opts.dados.operadora_ans_id
        state.dados.oper_nome = opts.dados.oper_nome
        state.dados.prestador_id = opts.dados.prestador_id
        state.dados.prest_nome = opts.dados.prest_nome
        state.dados.dt_faturamento = opts.dados.dt_faturamento
        state.dados.dt_prev_vencimento = opts.dados.dt_prev_vencimento
        state.dados.qt_arq = opts.dados.qt_arq
        state.dados.complementar = opts.dados.complementar ?opts.dados.complementar :false 

    },
    closeDialog: (state) => {
        state.dialog = false
    }
}
export default {
    namespaced: true,
    root: true,
    state,
    mutations
}